// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_invite_text_start = /** @type {(inputs: {}) => string} */ () => {
	return `You can share PeachLust with friends by sending an invite image or sharing a link. When your friend registers and tops up via your link, you’ll receive`
};

const id_invite_text_start = /** @type {(inputs: {}) => string} */ () => {
	return `Anda dapat membagikan PeachLust dengan teman-teman melalui gambar undangan atau membagikan link. Ketika teman Anda mendaftar dan mengisi ulang melalui link Anda, Anda akan menerima`
};

const de_invite_text_start = /** @type {(inputs: {}) => string} */ () => {
	return `Du kannst PeachLust mit Freunden teilen, indem du ihnen ein Einladungsbild schickst oder einen Link teilst. Wenn sich dein Freund über deinen Link registriert und auflädt, erhältst du`
};

const fr_invite_text_start = /** @type {(inputs: {}) => string} */ () => {
	return `Vous pouvez partager PeachLust avec vos amis en leur envoyant une image d'invitation ou en partageant un lien. Lorsqu'un ami s'inscrit et recharge via votre lien, vous recevez`
};

const es_invite_text_start = /** @type {(inputs: {}) => string} */ () => {
	return `Puedes compartir PeachLust con tus amigos enviando una imagen de invitación o compartiendo un enlace. Cuando tu amigo se registre y recargue su saldo a través de tu enlace, recibirás...`
};

const ru_invite_text_start = /** @type {(inputs: {}) => string} */ () => {
	return `Вы можете поделиться PeachLust с друзьями, отправив им изображение приглашения или ссылку. Когда ваш друг зарегистрируется и пополнит счёт по вашей ссылке, вы получите`
};

const zh_invite_text_start = /** @type {(inputs: {}) => string} */ () => {
	return `你可以通过分享图片或者复制链接的方式将我们的产品分享给你的朋友。当他们通过你的邀请成功注册并充值，你可以获得他们充值钻石`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "de" | "fr" | "es" | "ru" | "zh" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const invite_text_start = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.invite_text_start(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("invite_text_start", locale)
	if (locale === "en") return en_invite_text_start(inputs)
	if (locale === "id") return id_invite_text_start(inputs)
	if (locale === "de") return de_invite_text_start(inputs)
	if (locale === "fr") return fr_invite_text_start(inputs)
	if (locale === "es") return es_invite_text_start(inputs)
	if (locale === "ru") return ru_invite_text_start(inputs)
	if (locale === "zh") return zh_invite_text_start(inputs)
	return "invite_text_start"
};